export default __webpack_public_path__ + "static/cloud_banner-9d2222b09bd06bd0cb2fccfaa6552c6b.webp";